import { FaChevronLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { getInstallationCameraStatusLabel } from "./installationConfigUtils";

const InstallationDetailHero = ({
  sensorIdLabel,
  addressName,
  status,
  onBackToList,
}) => {
  const { t } = useTranslation();
  const displayAddress = addressName?.trim() || t("installation_address_empty");
  const displayStatus = status
    ? getInstallationCameraStatusLabel(t, status)
    : "";

  return (
    <header className="installation-detail-hero">
      {onBackToList && (
        <button
          type="button"
          className="installation-detail-hero-back"
          onClick={onBackToList}
        >
          <FaChevronLeft aria-hidden />
          {t("installation_detail_back_list")}
        </button>
      )}
      <div className="installation-detail-hero-main">
        <div className="installation-detail-hero-body">
          <span className="installation-detail-hero-eyebrow">
            {t("installation_row_sensor_id")}
          </span>
          <h1 className="installation-detail-hero-title">{sensorIdLabel}</h1>
          <p className="installation-detail-hero-address">{displayAddress}</p>
        </div>
        {displayStatus && (
          <span className="installation-detail-hero-status">
            {displayStatus}
          </span>
        )}
      </div>
    </header>
  );
};

export default InstallationDetailHero;
